import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { InitDataService } from '../system-services/InitData/InitData.service';
import { BasicPageLayoutOptions } from './BasicPageLayoutOptions';

@Component({
    selector: 'basic-page-layout',
    host: {
        class: 'pageWrapper greyBackground',
        '[class.pagelayout--loading]': 'options.loading'
    },
    template: `
        <basic-page-header>
            <ng-container page-header-title>
                <ng-content select="[page-header-title]"></ng-content>
            </ng-container>
            <ng-container page-header-description>
                <ng-content select="[page-header-description]"></ng-content>
            </ng-container>
        </basic-page-header>
        <basic-page-body [options]="options">
            <ng-container page-main-title>
                <ng-content select="[page-main-title]"></ng-content>
            </ng-container>
            <ng-container page-main-body>
                <ng-content select="[page-main-body]"></ng-content>
            </ng-container>
            <ng-container page-dlip-body>
                <ng-content select="[page-dlip-body]"></ng-content>
            </ng-container>
            <ng-container page-aside1-title>
                <ng-content select="[page-aside1-title]"></ng-content>
            </ng-container>
            <ng-container page-aside1-body>
                <ng-content select="[page-aside1-body]"></ng-content>
            </ng-container>
            <ng-container page-aside2-title>
                <ng-content select="[page-aside2-title]"></ng-content>
            </ng-container>
            <ng-container page-aside2-body>
                <ng-content select="[page-aside2-body]"></ng-content>
            </ng-container>
            <ng-container customAside
                ><ng-content select="[customAside]"></ng-content
            ></ng-container>
        </basic-page-body>
    `,
    standalone: false
})
export class BasicPageLayoutComponent {
    @Input()
    options: BasicPageLayoutOptions = {};
    @ViewChild('titleRef', { static: false })
    titleRef: ElementRef;
    @ViewChild('subtitleRef', { static: false })
    subtitleRef: ElementRef;

    constructor(public initData: InitDataService) {}
}
